
import BlankLayout from '../../../layout/blankLayout.vue'
import List from './list.vue'
import Edit from './editor.vue'
import { OFFER_LETTER_PAGE_TYPE } from '@/constant/company'

const basePath = '/v-admin/offer-letter-management/field'
const pageType = OFFER_LETTER_PAGE_TYPE.FIELD

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: BlankLayout,
  meta: {
    isNewPage: true,
    titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateFieldList'
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        permission: 'PERM_OFFER_CUSTOM_FIELD_MANAGEMENT',
        pageType: pageType,
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateFieldList'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        permission: 'PERM_OFFER_CUSTOM_FIELD_MANAGEMENT',
        pageType: pageType,
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateFieldAdd'
      }
    },
    {
      path: `${basePath}/edit/:fieldId`,
      component: Edit,
      meta: {
        permission: 'PERM_OFFER_CUSTOM_FIELD_MANAGEMENT',
        isEdit: true,
        pageType: pageType,
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateFieldEdit'
      }
    }
  ]
}
